"use client"


import { Home, MapPin, Clock, DollarSign, Shield, Wifi } from "lucide-react"
import { Helmet } from 'react-helmet-async';
import logo from '../../asset/logo.jpg'
import HotelBookingForm from "../HotelBookingForm";
function HotelsContent() {
  const hotelCategories = [
    {
      icon: Home,
      type: "Luxury Resorts",
      description:
        "Five-star properties with world-class amenities, spa services, fine dining, and premium accommodations",
    },
    {
      icon: MapPin,
      type: "Boutique Hotels",
      description: "Unique, characterful properties offering personalized service and authentic local experiences",
    },
    {
      icon: DollarSign,
      type: "Budget-Friendly",
      description: "Comfortable, clean accommodations at affordable rates perfect for budget-conscious travelers",
    },
    {
      icon: Shield,
      type: "Family Resorts",
      description: "Kid-friendly properties with entertainment, activities, and family-oriented amenities",
    },
    {
      icon: Clock,
      type: "Business Hotels",
      description: "Modern hotels near business districts with conference facilities and executive amenities",
    },
    {
      icon: Wifi,
      type: "Eco-Lodges",
      description: "Sustainable accommodations emphasizing environmental responsibility and nature immersion",
    },
  ]

  const features = [
    "Access to 100,000+ properties worldwide",
   
    
    "Loyalty rewards on every stay",
    "24/7 customer support",
 
  ]

  return (
    <div className="min-h-screen bg-background">
     
<Helmet>
  <title>Hotels — YS Sky Travel and Tour Agency P.L.C</title>
  <meta name="description" content="Book top-rated hotels at the best prices through YS Sky Travel and Tour Agency P.L.C." />
</Helmet>

      {/* Hero */}
     
<section className="relative h-72 bg-gradient-to-r from-primary-900 via-medical-600 to-blue-600 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={logo}
            alt="Contact us"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-medical-600/60"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-center w-full animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Hotel Bookings
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
          Find your perfect accommodation at your desired destination
            </p>
          </div>
        </div>

        {/* Animated Elements */}
        <div className="absolute top-20 right-20 w-32 h-32 bg-white/10 rounded-full animate-float"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-white/10 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
      </section>
      {/* Service Overview */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-card border border-border rounded-2xl p-8 mb-16">
            <h2 className="text-3xl font-bold mb-6 text-primary">About Our Hotel Booking Service</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>
                At YS Sky Travel and Tour Agency PLC, we make finding the right hotel easy. We offer a wide range of hotels worldwide, from luxury to budget options. We work with trusted partners to give you the best choices at the best prices.
              </p>
              <p>
               Whether for business or leisure, we help you find the perfect place to stay.
              </p>
          
            </div>
          </div>

          {/* Hotel Types */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-10 text-primary">Types of Accommodations</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {hotelCategories.map((category, idx) => {
                const Icon = category.icon
                return (
                  <div
                    key={idx}
                    className="bg-card border border-border rounded-xl p-6 hover:border-accent transition-colors"
                  >
                    <Icon className="w-10 h-10 text-accent mb-4" />
                    <h3 className="font-bold text-lg mb-2">{category.type}</h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">{category.description}</p>
                  </div>
                )
              })}
            </div>
          </div>

          {/* Amenities Guide */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16 w-full">

  {/* LEFT SECTION */}
  <div className="
    bg-gradient-to-br from-accent/10 to-primary/10 
    rounded-2xl p-6 sm:p-8 
    border border-accent/20 
    w-full
  ">
    <h3 className="text-2xl font-bold mb-6 text-primary">
      Why Book With Us
    </h3>

    <div className="space-y-4">
      {features.map((feature, idx) => (
        <div 
          key={idx} 
          className="flex gap-4 items-start"
        >
          <Shield className="w-6 h-6 text-accent flex-shrink-0 mt-1" />
          <span className="text-foreground text-base leading-relaxed">
            {feature}
          </span>
        </div>
      ))}
    </div>
  </div>

  {/* RIGHT SECTION: HOTEL FORM */}
  <div className="w-full">
    <HotelBookingForm />
  </div>

</div>


          {/* Top Destinations */}
          {/* <div className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-primary">Popular Hotel Destinations</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                { city: "Paris, France", specialty: "Romantic getaways, luxury accommodations" },
                { city: "Dubai, UAE", specialty: "Luxury resorts, ultra-modern hotels" },
                { city: "Bali, Indonesia", specialty: "Beach resorts, eco-lodges, boutique hotels" },
                { city: "Tokyo, Japan", specialty: "Business hotels, traditional ryokans" },
                { city: "New York, USA", specialty: "Business hotels, luxury apartments" },
                { city: "Barcelona, Spain", specialty: "Boutique hotels, city center locations" },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="bg-card border border-border rounded-xl p-6 hover:border-accent transition-colors"
                >
                  <h4 className="font-bold text-lg mb-2 text-primary">{item.city}</h4>
                  <p className="text-muted-foreground text-sm">{item.specialty}</p>
                </div>
              ))}
            </div>
          </div> */}

         
        </div>
      </section>

    </div>
  )
}

export default function Hotels() {
  return (
 
      <HotelsContent />
 
  )
}
